import { FC, SVGAttributes } from 'react';

export const GreenChevronsRight: FC<SVGAttributes<SVGElement>> = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="#80D59D" fillOpacity="0.48" />
    <path
      d="M13.5 16L17.5 12L13.5 8"
      stroke="#016C39"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 16L11.5 12L7.5 8"
      stroke="#016C39"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
